import { PlaceholdersId, TFComponent } from '@types';
import { IntegratedSolutionCardPlaceholder } from './integratedSolutionCard';

export const integratedSolutionCard: TFComponent = {
	component: IntegratedSolutionCardPlaceholder,
	id: PlaceholdersId.integratedSolutionCard,
	name: 'integratedSolutionCard',
};
